import React, { Component } from "react";
import lang from "../lang/index";
import PbAjax from "up-pbajax";
import url from "c-url";
import registerpb from "../regi";
import publicpb from "../publicpb";
import loading from "c-loading";
import Notification from "./notification";

import Contact from "./contact";
import VerifyFail from "./verify-fail";
import VerifySuccess from "./verify-success";
import CaptchaVerify from "./captcha-verify";
const pbajax = new PbAjax();
const serviceMap = {
    CN: "bj-login",
    US: "us-login",
    EUROPE: "europe-login",
    IN: "in-login",
};
const service = serviceMap[url.query("region")] || "account";

class Verify extends Component {
    constructor(props) {
        super(props);
        this.state = {
            verifyResult: 0,
        };
    }

    // 当’图片验证组件（captcha-verify）’过程中发现verifyCode无效（如：过期，或错误）时，
    // 将直接显示验证失败的界面
    verifyCodeFailed() {
        this.setState((prev) => ({ ...prev, verifyResult: "fail" }));
    }

    submit() {
        let data = {
            verifyCode: url.query("code"),
        };
        let ua =
            window.navigator.userAgent +
            (lang.businessType == "upVoice" ? " feature/6666" : "");

        pbajax.do(
            {
                service,
                api: "/email/register/verify",
                header: {
                    UserAgent: ua,
                },
                inchina: 1,
            },
            new registerpb.Email.RegisterVerify.Request(data),
            (res) => {
                loading.hide();
                let dataWrap = publicpb.Result.decode(res);
                console.log("verify", dataWrap);
                if (dataWrap.code == 1) {
                    this.setState({
                        verifyResult: "success",
                    });
                } else {
                    this.setState({
                        verifyResult: "fail",
                    });
                }
            },
            () => {
                loading.hide();
                new Notification({
                    content: lang.template("网络连接有误, 请稍后再试"),
                }).create();
            }
        );
    }
    componentWillMount() {
        loading.show({
            text: "loading",
        });
        // this.submit();
    }

    render() {
        let verifyResult = this.state.verifyResult;
        let Result;

        if (verifyResult === 0) {
            Result = (
                <CaptchaVerify
                    verifyPassed={this.submit.bind(this)}
                    verifyCodeFailed={this.verifyCodeFailed.bind(this)}
                />
            );
        } else if (verifyResult == "success") {
            Result = <VerifySuccess />;
        } else if (verifyResult == "fail") {
            Result = <VerifyFail />;
        }

        return <div>{Result}</div>;
    }
}

export default Verify;



// WEBPACK FOOTER //
// ./js/view/verify.js